import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'lib/@mui';

import { EZLOGIC_BUTTON_RESTORE_THIS_BACKUP } from 'constants/language_tokens';
import { isCurrentControllerConnectedSelector } from '../selectors';
import { useTranslate } from 'features/languages';

export const RestoreBackupButton = ({ handleOpenRestoreBackupModal }) => {
    const isCurrentControllerConnected = useSelector(isCurrentControllerConnectedSelector);
    const { t } = useTranslate();

    return (
        <Button
            color="primary"
            variant="contained"
            className="primary-btn"
            disabled={!isCurrentControllerConnected}
            onClick={handleOpenRestoreBackupModal}
        >
            {t(EZLOGIC_BUTTON_RESTORE_THIS_BACKUP)}
        </Button>
    );
};
